import { toast } from 'sonner';
import { getEdgeFunctionErrorMessage } from './edgeFunction';

/**
 * Shows a toast error with the edge function name included
 */
export function toastEdgeFunctionError(
  functionName: string, 
  error: any, 
  prefix?: string
): string {
  const message = getEdgeFunctionErrorMessage(error, functionName);
  const fullMessage = prefix ? `${prefix}: ${message}` : message;
  
  toast.error(fullMessage);
  return message;
}